import { clientEntry } from '@client/lib/entry-client'
import App from './App'

clientEntry(App)
